import React, { useState, useEffect, useRef } from 'react'
import {Grid,
    Typography,
    Tooltip,
   
} from '@material-ui/core'
import {
    LoonsSnackbar,
} from 'app/components/LoonsLabComponents'
import { ValidatorForm } from 'app/components/LoonsLabComponents'
import {
    fullScreenRequestInsideApp,
    makeid,
} from '../../../../utils'
import FullscreenIcon from '@material-ui/icons/Fullscreen'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'
import BackspaceIcon from '@material-ui/icons/Backspace'
import SettingsIcon from '@material-ui/icons/Settings'

const WidgetComponent = (props) => {
    const {
        fieldset,
        title,
        headerColor,
        height,
        id,
        onClickSetting,
        onClickRemove,
        edit,
        fullScreenVisibility,
        searchParams,
    } = props

    const [alert, setAlert] = useState(false)
    var [message, setMessage] = useState('')
    var [severity, setSeverity] = useState('success')
    const [divWidth, setWidth] = useState()
    var [formData, setformData] = useState({})

    const ref = useRef(null)

    useEffect(() => {
        //console.log('width', ref.current ? ref.current.offsetWidth : 0);
        setWidth(ref.current.offsetWidth)
        setInterval(() => getSize(), 1000)
    }, [ref.current])

    useEffect(() => {
        console.log('searchParams', searchParams);

    }, [searchParams])

    const handleChange = (data) => {
        const { onChange } = props
        onChange &&
            onChange({
                data,
            })
    }

    const setFields = () => {
        var formData = Object.assign({}, formData)

        fieldset.map((item, i) => {
            formData[item.fieldName] = null
        })

        setformData(formData)
    }

    const onInputChange = async (name, value) => {
        formData[name] = value
        setformData({ ...formData })
        console.log('formData', formData)
    }

    const getSize = () => {
        //console.log('width', ref.current ? ref.current.offsetWidth : 0);
        if (ref.current) {
            setWidth(ref.current.offsetWidth)
        }
    }

    const getResponsive = (item) => {
        if (divWidth > 0 && divWidth < 600) {
            return item.otherProps.xs
        } else if (divWidth > 600 && divWidth < 900) {
            return item.otherProps.sm
        } else if (divWidth > 900 && divWidth < 1200) {
            return item.otherProps.md
        } else if (divWidth > 1200 && divWidth < 1536) {
            return item.otherProps.lg
        } else if (divWidth > 1536) {
            return item.otherProps.xl
        }
    }

    const reload = () => {
        // onReload()
    }
  

    return (
        <div
            id={
                id
            } /* style={{ borderStyle: "solid", borderColor: "gray", borderWidth: 1 }} */
            //maxConstraints={[300, 300]}
            // height={this.state.height} width={this.state.width} onResize={this.onResize}
            style={{ height: 'calc(100% + -40px)' }}
        >
            <Grid
                style={{ backgroundColor: headerColor }}
                container
                className="px-1 pt-1 "
            >
                <Grid
                    className="px-1 pl-2 inline flex items-center align-middle"
                    item
                    lg={10}
                    md={10}
                    sm={9}
                    xs={9}
                >
                    <img
                        style={{
                            width: '1.3em',
                            height: '1.3em',
                            marginTop: -1,
                        }}
                        src="/assets/icons/file.svg"
                        alt="Out of Stock"
                    />
                    <Typography
                        className="font-medium ml-1"
                        variant="h6"
                        style={{
                            fontSize: 16,
                            color: '#374151' /* themeColors[activeTheme].palette.primary.main */,
                        }}
                    >
                        {title}
                    </Typography>
                </Grid>

                <Grid
                    className="flex justify-end"
                    item
                    lg={2}
                    md={2}
                    sm={3}
                    xs={3}
                >
                    {fullScreenVisibility ? (
                        <Tooltip
                            title="Full Screen"
                            className="hide-on-fullScreen"
                        >
                            <FullscreenIcon
                                onClick={() => {
                                    fullScreenRequestInsideApp(id)
                                    getSize()
                                }}
                                className="cursor-pointer"
                                color="action"
                            />
                        </Tooltip>
                    ) : null}

                    {fullScreenVisibility ? (
                        <Tooltip title="Back" className="show-on-fullScreen">
                            <BackspaceIcon
                                onClick={() => {
                                    fullScreenRequestInsideApp(id)
                                    getSize()
                                }}
                                className="cursor-pointer"
                                color="action"
                            />
                        </Tooltip>
                    ) : null}

                    {edit ? (
                        <div className="flex justify-end">
                            <Tooltip title="Setting">
                                <SettingsIcon
                                    onClick={() => {
                                        onClickSetting()
                                    }}
                                    className="cursor-pointer"
                                    color="action"
                                />
                            </Tooltip>
                            <Tooltip title="Remove">
                                <DeleteOutlineIcon
                                    onClick={() => {
                                        onClickRemove()
                                    }}
                                    className="cursor-pointer"
                                    color="action"
                                />
                            </Tooltip>
                        </div>
                    ) : null}
                </Grid>
            </Grid>
            <div
                className="px-2 pb-1 pt-2 overflow-auto widget-container h-full"
                style={{ height: height }}
            >
                <ValidatorForm
                    
                >
                    <Grid container ref={ref} spacing={1}>
                        {fieldset.map((item, i) => {
                            if (item.type == 'RMSD_requested_orders') {
                                //return (<RMSD_requested_orders></RMSD_requested_orders>)
                            }

                        })}
                    </Grid>
                </ValidatorForm>
            </div>

            <LoonsSnackbar
                open={alert}
                onClose={() => {
                    setAlert(false)
                }}
                message={message}
                autoHideDuration={3000}
                severity={severity}
                elevation={2}
                variant="filled"
            ></LoonsSnackbar>
        </div>
    )
}

WidgetComponent.defaultProps = {
    props: {
        fieldset: [
            {
                id: 1,
                displayName: null,
                status: 'Active',
                style: "{{ width: '100%' }}",
                type: 'input', //autocomplete,radio,checkBox,textfield,datePicker
                className: 'w-full', //new added
                otherProps: { lg: 6, md: 6, sm: 6, xs: 6 }, //new added
                placeholder: 'Name', //new added
                fieldName: 'test_name', //new added for API data field name

                question: 'scars',
                displayInSmallView: false,
                widget_id: 1,
                createdAt: '2022-05-03T11:00:52.513Z',
                updatedAt: '2022-05-03T11:00:52.513Z',

                ExaminationWidgetInputAnswers: [
                    {
                        id: 1,
                        displayNa: 'NO',
                        status: 'Active',
                        value: 'No',
                        isDefault: true,
                        widget_in: 1,
                        createdAt: '2022-05-03T11:02:47.280Z',
                        updatedAt: '2022-05-03T11:02:47.280Z',
                    },
                ],
            },

            {
                id: 1,
                displayName: null,
                status: 'Active',
                style: "{{ width: '100%' }}",
                type: 'autocomplete',
                className: 'w-full', //new added
                otherProps: { lg: 6, md: 6, sm: 6, xs: 6 }, //new added
                placeholder: 'Name', //new added
                fieldName: 'test_name', //new added for API data field name

                question: 'scars',
                displayInSmallView: true,
                widget_id: 1,
                createdAt: '2022-05-03T11:00:52.513Z',
                updatedAt: '2022-05-03T11:00:52.513Z',

                ExaminationWidgetInputAnswers: [
                    {
                        id: 1,
                        displayNa: 'NO',
                        status: 'Active',
                        value: 'No',
                        isDefault: true,
                        widget_in: 1,
                        createdAt: '2022-05-03T11:02:47.280Z',
                        updatedAt: '2022-05-03T11:02:47.280Z',
                    },
                ],
            },
            {
                id: 1,
                displayName: null,
                status: 'Active',
                style: "{{ width: '100%' }}",
                type: 'checkBox',
                className: 'w-full mt--2', //new added
                otherProps: { lg: 6, md: 6, sm: 6, xs: 6 }, //new added
                placeholder: 'Name', //new added
                fieldName: 'test_name', //new added for API data field name

                question: 'scars',
                displayInSmallView: true,
                widget_id: 1,
                createdAt: '2022-05-03T11:00:52.513Z',
                updatedAt: '2022-05-03T11:00:52.513Z',

                ExaminationWidgetInputAnswers: [
                    {
                        id: 1,
                        displayNa: 'Yes',
                        status: 'Active',
                        value: 'Yes',
                        isDefault: true,
                        widget_in: 1,
                        createdAt: '2022-05-03T11:02:47.280Z',
                        updatedAt: '2022-05-03T11:02:47.280Z',
                    },
                    {
                        id: 1,
                        displayNa: 'No',
                        status: 'Active',
                        value: 'No',
                        isDefault: false,
                        widget_in: 1,
                        createdAt: '2022-05-03T11:02:47.280Z',
                        updatedAt: '2022-05-03T11:02:47.280Z',
                    },
                ],
            },
            {
                id: 1,
                displayName: null,
                status: 'Active',
                style: "{{ width: '100%' }}",
                type: 'datePicker',
                className: 'w-full', //new added
                otherProps: { lg: 6, md: 6, sm: 6, xs: 6 }, //new added
                placeholder: 'Date', //new added
                fieldName: 'test_date', //new added for API data field name

                question: 'scars',
                displayInSmallView: true,
                widget_id: 1,
                createdAt: '2022-05-03T11:00:52.513Z',
                updatedAt: '2022-05-03T11:00:52.513Z',

                ExaminationWidgetInputAnswers: [
                    {
                        id: 1,
                        displayNa: 'Yes',
                        status: 'Active',
                        value: 'Yes',
                        isDefault: true,
                        widget_in: 1,
                        createdAt: '2022-05-03T11:02:47.280Z',
                        updatedAt: '2022-05-03T11:02:47.280Z',
                    },
                ],
            },
        ],

        id: `widget-${makeid()}`,
        edit: false,
        fullScreenVisibility: true,
    },
}

export default WidgetComponent
